// URLSearchParams.get returns strings, so a missing id interpolated into a
// navigation URL (`?scenarioId=${undefined}`) arrives here as the literal
// "undefined"/"null". Those are truthy and would slip past every `!id` guard,
// reaching the backend as `/scenario/undefined` which 500s on Long parsing.
// Normalize them (and blanks) to null at the URL boundary.
export function sanitizeUrlId(value) {
  if (value == null) return null;
  const trimmed = String(value).trim();
  if (!trimmed || trimmed === "undefined" || trimmed === "null") return null;
  return trimmed;
}
